import React, {useContext, useEffect, useState} from 'react';
import {Container, Row, Col, Card, Button} from "react-bootstrap";
import {IoWaterOutline} from "react-icons/io5";
import {FaRegBuilding} from "react-icons/fa";
import {
    SITE_ENTITY,
    SITE_ENTITY_LABEL,
    SYSTEM_ENTITY,
    VARIANT_SITES,
    VARIANT_SYSTEMS,
    WATER_SYSTEM_ENTITY_LABEL
} from "../../Constants/constants";
import {HiOutlineCog,} from "react-icons/hi";
import './ReportsPage.css'
import '../../fonts.css'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import WaterConsumption from "../../Components/ReportsGeneratorComponents/WaterConsumption/WaterConsumption";
import NumberOfLeakAlertsChart
    from "../../Components/ReportsGeneratorComponents/NumberOfLeakAlertsChart/NumberOfLeakAlertsChart";
import AlertsByFlowType from "../../Components/ReportsGeneratorComponents/AlertsByFlowType/AlertsByFlowType";
import ConsumptionAndPotentialWaste
    from "../../Components/ReportsGeneratorComponents/ConsumptionAndPotentialWaste/ConsumptionAndPotentialWaste";
import NumberOfLeakAlertsPie
    from "../../Components/ReportsGeneratorComponents/NumberOfLeakAlertsPie/NumberOfLeakAlertsPie";
import LeakVolumeAndWaterConsumption
    from "../../Components/ReportsGeneratorComponents/LeakVolumeAndWaterConsumption/LeakVolumeAndWaterConsumption";
import LeakVolumeOverTime from "../../Components/ReportsGeneratorComponents/LeakVolumeOverTime/LeakVolumeOverTime";
import WaterConsumptionAndAlerts
    from "../../Components/ReportsGeneratorComponents/WaterConsumptionAndAlerts/WaterConsumptionAndAlerts";
import StatisticsData from "../../Components/ReportsGeneratorComponents/StatisticalData/StatisticsData";
import ColumnCard from "../../Components/ReportsGeneratorComponents/ColumnCard/ColumnCard";
import SettingsModal from "../../Components/ReportsGeneratorComponents/SettingsModal/SettingsModal";
import {apolloClientReports} from "../../GraphQL/config";
import {QUERY_GET_USER_PREFERENCE} from "../../GraphQL/ReportGenerator/queries";
import {SET_USER_PREFERENCES} from "../../Store/ActionTypes/General/actionTypes";
import {store} from "../../Store/store";
import SiteConsumptionDataTable from "../../Components/ReportsGeneratorComponents/WaterConsumptionDataTable/SiteConsumptionDataTable";
import WaterSystemConsumptionDataTable from "../../Components/ReportsGeneratorComponents/WaterConsumptionDataTable/WaterSystemConsumptionDataTable";

export default function ReportsPage() {
    const colStyle = {padding: '5px'};
    const {dispatch} = useContext(store);
    const [smShow, setSmShow] = useState(false);
    const [userPreference, setUserPreference] = useState();
    const customStyle = true;

    const queryUserPreferences = () => {
        apolloClientReports.query({
            query: QUERY_GET_USER_PREFERENCE
        }).then(res => {
            const userPreference = res?.data?.userPreference;
            if (!userPreference) {
                console.error(`Data from UserPreference is empty`);
            } else {
                setUserPreference(userPreference);
                dispatch({
                    type: SET_USER_PREFERENCES,
                    payload: {
                        volumeMeasUnitOptions: userPreference.volumeUnit,
                        currencyUnits: userPreference.currencyUnit,
                        waterPrice: userPreference.waterPrice
                    }
                });
            }
        });
    }

    useEffect(() => {
        queryUserPreferences();
    }, [userPreference]);

    return (
        <Container fluid style={{backgroundColor: '#f6f6f6'}} className={'ReportsPage'}>
            {/* ============== Summary Data - All Systems ============== */}
            <Row>
                <Col style={colStyle}>
                    <Card style={{backgroundColor: '#ececec'}}>
                        <Card.Body>
                            <Row>
                                <Col md={2}>
                                    <p className={'card-title-main bold-title'}><IoWaterOutline/>Summary Data - All Systems</p>
                                </Col>
                                <Col md={8}>
                                    <h2 className='mb-0 mr-5 text-primary'> Beta Release </h2>
                                </Col>
                                <Col md={2}>
                                    <Button className='mb-1 float-right' onClick={() => setSmShow(true)}>
                                        <HiOutlineCog/> Settings
                                    </Button>
                                </Col>
                                {userPreference ? <SettingsModal show={smShow} setShow={setSmShow} data={userPreference}/> : null}
                            </Row>
                            {/* ============== Statistics Data ============== */}
                            <Row>
                                <StatisticsData settingsData={userPreference}/>
                            </Row>
                            <Row>
                                <ColumnCard mdSize={5} style={colStyle} title={'Water Consumption'}
                                            component={WaterConsumption}/>
                                <ColumnCard mdSize={5} style={colStyle} title={'Number of Leak Alerts'}
                                            component={NumberOfLeakAlertsChart}/>
                                <ColumnCard mdSize={2} style={colStyle} title={'Alerts by Flow Type'}
                                            component={AlertsByFlowType}/>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            {/* ============== Site Data ============== */}
            <Row>
                <Col style={colStyle}>
                    <Card style={{backgroundColor: '#ececec'}}>
                        <Card.Body>
                            <Row>
                                <Col md={12}>
                                    <p className={'card-title-main bold-title'}><FaRegBuilding/> Site Data</p>
                                </Col>
                            </Row>
                            <Row>
                                {/* ============== Consumption & Potential Waste ============== */}
                                <ColumnCard mdSize={4} style={colStyle} title={'Consumption & Potential Waste'}
                                            variant={VARIANT_SITES} component={ConsumptionAndPotentialWaste}
                                            entityType={SITE_ENTITY} entityLabel={SITE_ENTITY_LABEL}
                                            customStyle={customStyle}
                                />
                                {/* ============== Water Consumption Data per Site ============== */}
                                <ColumnCard mdSize={8} style={colStyle} title={'Water Consumption Data per Site'}
                                            component={SiteConsumptionDataTable} entityLabel={SITE_ENTITY_LABEL}
                                            customStyle={customStyle}
                                />
                            </Row>
                            <Row>
                                {/* ============== Number of Leak Alerts ============== */}
                                <ColumnCard mdSize={4} style={colStyle} title={'Number of Leak Alerts'}
                                            variant={VARIANT_SITES} component={NumberOfLeakAlertsPie}
                                            entityType={SITE_ENTITY} entityLabel={SITE_ENTITY_LABEL}
                                            customStyle={customStyle}
                                />

                                {/* ============== Leak Volume and Water Consumption ============== */}
                                <ColumnCard mdSize={4} style={colStyle} title={'Leak Volume and Water Consumption'}
                                            variant={VARIANT_SITES} component={LeakVolumeAndWaterConsumption}
                                            entityType={SITE_ENTITY} entityLabel={SITE_ENTITY_LABEL}
                                            customStyle={customStyle}
                                />

                                {/* ============== Leak Volume Over Time (Compare Sites) ============== */}
                                <ColumnCard mdSize={4} style={colStyle} title={'Leak Volume Over Time (Compare Sites)'}
                                            variant={VARIANT_SITES} component={LeakVolumeOverTime}
                                            entityLabel={SITE_ENTITY_LABEL}
                                            customStyle={customStyle}
                                />

                            </Row>

                            <Row>
                                {/* ============== Water Consumption and Alerts (Compare Sites) ============== */}
                                <ColumnCard mdSize={12} style={colStyle} title={'Water Consumption and Alerts (Compare Sites)'}
                                            variant={VARIANT_SITES} component={WaterConsumptionAndAlerts}
                                            entityLabel={SITE_ENTITY_LABEL}
                                            customStyle={customStyle}
                                />
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            {/* ============== System Data ============== */}
            <Row>
                <Col style={colStyle}>
                    <Card style={{backgroundColor: '#ececec'}}>
                        <Card.Body>
                            <Row>
                                <Col md={12}>
                                    <p className={'card-title-main bold-title'}><HiOutlineCog/>Water System Data</p>
                                </Col>
                            </Row>
                            <Row>
                                {/* ============== Consumption & Potential Waste ============== */}
                                <ColumnCard mdSize={4} style={colStyle} title={'Consumption & Potential Waste'}
                                            variant={VARIANT_SYSTEMS} component={ConsumptionAndPotentialWaste}
                                            entityType={SYSTEM_ENTITY} entityLabel={WATER_SYSTEM_ENTITY_LABEL}
                                            customStyle={customStyle}
                                />

                                {/* ============== Water Consumption Data per System ============== */}
                                <ColumnCard mdSize={8} style={colStyle} title={'Water Consumption Data per System'}
                                            component={WaterSystemConsumptionDataTable} entityLabel={WATER_SYSTEM_ENTITY_LABEL}
                                            customStyle={customStyle}
                                />
                            </Row>
                            <Row>
                                {/* ============== Number of Leak Alerts ============== */}
                                <ColumnCard mdSize={4} style={colStyle} title={'Number of Leak Alerts'}
                                            variant={VARIANT_SYSTEMS} component={NumberOfLeakAlertsPie}
                                            entityType={SYSTEM_ENTITY} entityLabel={WATER_SYSTEM_ENTITY_LABEL}
                                            customStyle={customStyle}
                                />

                                {/* ============== Leak Volume and Water Consumption ============== */}
                                <ColumnCard mdSize={4} style={colStyle} title={'Leak Volume and Water Consumption'}
                                            variant={VARIANT_SYSTEMS} component={LeakVolumeAndWaterConsumption}
                                            entityType={SYSTEM_ENTITY} entityLabel={WATER_SYSTEM_ENTITY_LABEL}
                                            customStyle={customStyle}
                                />

                                {/* ============== Leak Volume Over Time (Compare Sites) ============== */}
                                <ColumnCard mdSize={4} style={colStyle} title={'Leak Volume Over Time (Compare Systems)'}
                                            variant={VARIANT_SYSTEMS} component={LeakVolumeOverTime}
                                            entityLabel={WATER_SYSTEM_ENTITY_LABEL}
                                            customStyle={customStyle}
                                />
                            </Row>

                            <Row>
                                {/* ============== Water Consumption and Alerts (Compare Sites) ============== */}
                                <ColumnCard mdSize={12} style={colStyle} title={'Water Consumption and Alerts (Compare Systems)'}
                                            variant={VARIANT_SYSTEMS} component={WaterConsumptionAndAlerts}
                                            entityLabel={WATER_SYSTEM_ENTITY_LABEL}
                                            customStyle={customStyle}

                                />

                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}